class CepUtils {
  static cleanCep(cep) {
    return cep.replace(/[^0-9]/g, '');
  }

  static formatCep(cep) {
    const cleaned = this.cleanCep(cep);
    if (cleaned.length <= 5) {
      return cleaned;
    }
    return cleaned.substring(0, 5) + '-' + cleaned.substring(5, 8);
  }

  static async buscarEndereco(cep) {
    const cepLimpo = this.cleanCep(cep);

    if (cepLimpo.length !== 8) {
      return null;
    }

    try {
      const response = await fetch(`https://viacep.com.br/ws/${cepLimpo}/json/`);
      const data = await response.json();

      if (data.erro) {
        return null;
      }

      return {
        logradouro: data.logradouro || '',
        bairro: data.bairro || '',
        cidade: data.localidade || '',
        estado: data.uf || '',
        cep: this.formatCep(data.cep || cepLimpo),
      };
    } catch (error) {
      console.error('Erro ao buscar CEP:', error);
      return null;
    }
  }
}

export default CepUtils;
